module.exports = __webpack_public_path__ + "static/img/WeChatCode.9de037a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/WeChatCode.png
// module id = nXwY
// module chunks = 1